export default __webpack_public_path__ + "static/media/eye1.6eaae79e.png";